import ModelService from "./abstract/ModelService";
import Contract from "../models/Contract";

export default class ContractService extends ModelService {
  constructor() {
    super('/contracts', Contract);
  }

  createSignOff(modelId, model) {
    return new Promise((resolve, reject) => {
      this.get(config.app.api_url + this.modelPath + '/' + modelId + '/sign-off', this.modelName ? { [this.modelName]: model } : model).then(data => {
        resolve(data)
      }).catch((e) => reject(e.response));
    });
  }

  signOff(modelId, model) {
    return new Promise((resolve, reject) => {
      this.put(config.app.api_url + this.modelPath + '/' + modelId + '/sign-off', this.modelName ? { [this.modelName]: model } : model).then(data => {

        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }

  download(model) {
    axios({
      url: config.app.api_url + this.modelPath + '/' + model.id + '/download',
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', `contract-${model.contract_number}.pdf`);
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  }

  downloadExcel() {
    axios({
      url: config.app.api_url + this.modelPath + '/export/excel',
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');

      fileLink.href = fileURL;
      fileLink.setAttribute('download', `contracts.xlsx`);
      document.body.appendChild(fileLink);

      fileLink.click();
    });
  }

  editOrderNumber(modelId, newOrderNumber) {
    return new Promise((resolve, reject) => {
      this.put(config.app.api_url + this.modelPath + '/' + modelId + '/order-number', { order_number: newOrderNumber }).then(data => {
        let item = new this.Model(data);
        resolve(item);
      }).catch((e) => reject(e.response));
    });
  }
}
